<template>
  <v-container fluid>
    <section-title-with-request-id
    :request-id="repairProp.number"
    title="pages.repair.repairStatusChangeHistory"/>
    <v-row dense>
      <v-col>
        <main-data-table
        number-pages
        :headers="headers"
        :items="items"
        :page.sync="page"
        :size.sync="size"
        :with-search="false"
        :loading="isLoading"
        :onUpdateSize="tryToFetchHistoryByCriteria"
        :onPerviousBtnClick="tryToFetchHistoryByCriteria"
        :onNextBtnClick="tryToFetchHistoryByCriteria"
        :total-elements="totalElements">
          <template v-slot:[`header.createdAt`]="{ header }">
              {{$t(header.text, {'0': getTimeZoneInNumber(new Date())})}}
          </template>
          <template v-slot:[`header.changedBy`]="{ header }">
              {{$t(header.text)}}
          </template>
          <template v-slot:[`header.role`]="{ header }">
              {{$t(header.text)}}
          </template>
          <template v-slot:[`header.oldStatus`]="{ header }">
              {{$t(header.text)}}
          </template>
          <template v-slot:[`header.newStatus`]="{ header }">
              {{$t(header.text)}}
          </template>

          <template v-slot:[`item.createdAt`]="{ item }">
              <span>
                {{getDateNewYorkFormat(item.createdAt)}}
              </span> 
          </template>
          <template v-slot:[`item.changedBy`]="{ item }">
              <span>
                {{item.changedBy}}
              </span>
          </template>
          <template v-slot:[`item.role`]="{ item }">
              <span>
                {{$t(`roles.CONST_${item.role}`)}}
              </span>
              <span class="font-italic font-weight-bold">
                {{getOldRolesText(item)}}
              </span>
          </template>
          <template v-slot:[`item.oldStatus`]="{ item }">
              <span>
                {{$t(getStatus(item.oldStatus))}}
              </span>
          </template>
          <template v-slot:[`item.newStatus`]="{ item }">
              <span>
                {{$t(getStatus(item.newStatus))}}
              </span>
          </template>
        </main-data-table>
      </v-col>
    </v-row>

    <export-xlsx-row
    :width="150"
    :height="50"
    :disabled="items.length === 0"
    :loading.sync="isLoading"
    class="px-4 mt-4"
    name="export.title.repairHistoryTab"
    :exporter="getExporter"/>
  </v-container>
</template>
<script>
import DateUtil from '@/utils/DateUtil'
import { fetchHistoryByCriteria } from '@/repositories/repairRepo'
import { execHttpRequestThrowable } from '@/services/http'
import { getRepairStatusByKey } from '@/utils/statusesUtil'
import { exportRepairHistoryTabXlsx } from '@/repositories/exportRepo'
import { getOldRolesAsText } from "@/services/tabs/historyTab.service"
import MainDataTable from '@/components/common/MainDataTable'
import ExportXlsxRow from '@/components/common/ExportXlsxRow'
import SectionTitleWithRequestId from '@/components/common/process-tabs/shared/SectionTitleWithRequestId'
export default {
  name: 'HistoryTabRepair',
  components: {
    MainDataTable,
    ExportXlsxRow,
    SectionTitleWithRequestId
  },
  props: {
    data: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'headers.date',
          align: 'start',
          sortable: true,
          value: 'createdAt'
        },{
          text: 'headers.changedBy',
          align: 'start',
          sortable: true,
          value: 'changedBy'
        },{
          text: 'headers.role',
          align: 'start',
          sortable: true,
          value: 'role'
        },{
          text: 'headers.oldStatus',
          align: 'start',
          sortable: true,
          value: 'oldStatus'
        }, {
          text: 'headers.newStatus',
          align: 'start',
          sortable: true,
          value: 'newStatus'
        }
      ],
      items: [],
      size: 10,
      page: 1,
      totalElements: 0,
      isLoading: false
    }
  },
  computed: {
    getExporter() {
      return async () => await exportRepairHistoryTabXlsx(this.$route.params.id)
    },
    repairProp: {
      get: function() {
        return this.$props.data
      },
      set: function(v) {
        this.$emit('update:data', v)
      }
    }
  },
  methods: {
    getDateNewYorkFormat(d) {
      return DateUtil.getDateNewYorkFormat(d)
    },
    getStatus(k) {
      return getRepairStatusByKey(k)
    },
    async tryToFetchHistoryByCriteria() {
      const r = await execHttpRequestThrowable(async () => await fetchHistoryByCriteria(this.$route.params.id, this.size, this.page - 1), {}, v => this.isLoading = v)
      const p = r.response.data
      this.totalElements = p.totalElements
      this.items = [...p.content]
    },
    getTimeZoneInNumber(d) {
      return DateUtil.getTimeZoneInNumber(d)
    },
    getOldRolesText({ oldRoles }) {
      return getOldRolesAsText(oldRoles)
    }
  },
  async mounted() {
    await this.tryToFetchHistoryByCriteria()
  }
}
</script>
<style>

</style>